import ThemifyIconContainer from "../../../Components/Icon/ThemifyIcon/ThemifyIconContainer";

const ThemifyIcon = () => {
  return <ThemifyIconContainer />;
};

export default ThemifyIcon;
